import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Stack, Alert } from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import axios from '../api/axiosConfig';

const ChangePasswordPage = ({ user, onPasswordChangeSuccess }) => {
  const [pwForm, setPwForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [errorMessage, setErrorMessage] = useState('');

  const handleChangePassword = async () => {
    setErrorMessage('');

    if (!pwForm.currentPassword || !pwForm.newPassword || !pwForm.confirmPassword) {
      setErrorMessage('모든 항목을 입력해주세요.');
      return;
    }

    if (pwForm.newPassword !== pwForm.confirmPassword) {
      setErrorMessage('새 비밀번호와 비밀번호 확인이 일치하지 않습니다.');
      return;
    }

    if (pwForm.currentPassword === pwForm.newPassword) {
      setErrorMessage('새 비밀번호는 기존 비밀번호(자격증 번호)와 다르게 설정해야 합니다.');
      return;
    }

    try {
      await axios.post('/api/member/change-password', {
        memberId: user.id,
        currentPassword: pwForm.currentPassword,
        newPassword: pwForm.newPassword,
      });

      alert('비밀번호가 성공적으로 변경되었습니다. 메인 화면으로 이동합니다.');

      // App.js의 handlePasswordChangeSuccess 실행 (user 상태 갱신 및 화면 전환)
      if (typeof onPasswordChangeSuccess === 'function') {
        onPasswordChangeSuccess();
      }
    } catch (error) {
      console.error('비밀번호 변경 오류:', error);
      setErrorMessage(error.response?.data || '비밀번호 변경 중 오류가 발생했습니다.');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Card elevation={3} sx={{ maxWidth: 450, width: '100%', borderRadius: '16px', p: 2 }}>
        <CardContent>
          <Stack spacing={2.5}>
            <Box sx={{ textAlign: 'center', mb: 1 }}>
              <LockResetIcon sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
              <Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a' }}>
                초기 비밀번호 변경
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                보안을 위해 초기 비밀번호(교원자격증 번호)를 변경한 후 서비스를 이용하실 수 있습니다.
              </Typography>
            </Box>

            {errorMessage && (
              <Alert severity="error" sx={{ borderRadius: '10px' }}>
                {errorMessage}
              </Alert>
            )}

            <TextField
              fullWidth
              type="password"
              label="현재 비밀번호 (자격증 번호) *"
              value={pwForm.currentPassword}
              onChange={(e) => setPwForm({ ...pwForm, currentPassword: e.target.value })}
            />

            <TextField
              fullWidth
              type="password"
              label="새 비밀번호 *"
              value={pwForm.newPassword}
              onChange={(e) => setPwForm({ ...pwForm, newPassword: e.target.value })}
            />

            <TextField
              fullWidth
              type="password"
              label="새 비밀번호 확인 *"
              value={pwForm.confirmPassword}
              onChange={(e) => setPwForm({ ...pwForm, confirmPassword: e.target.value })}
            />

            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleChangePassword}
              sx={{ borderRadius: '10px', py: 1.4, fontWeight: 700, fontSize: '1rem', mt: 1 }}
            >
              비밀번호 변경 및 시작하기
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ChangePasswordPage;